<template lang="pug">
  .pill.xs-f-xxsmall.max-at-tweak(:class="pillVariantClass") {{ text }}
  
</template>

<script>
  export default {
    name: "Pill",
    props: {
      text: {
        type: String,
        required: true
      },

      variant: String
    },

    computed: {
      pillVariantClass() {
        return this.variant || 'secondary';
      }
    }
   }
</script>

<style scoped lang="stylus">

  .pill
    border-radius 4px
    padding 0 0.4em
    display inline-block

  .info
    color color-slate
    background-color bg-color-info

  .secondary
    color color-slate
    background-color color-gray-light

  .danger
    background-color color-red
    color white

  .light-danger
    color color-slate
    background-color bg-color-error

  .warning
    background-color #ffc107
    color color-gray-light


</style>